<!-- 个人中心 - 修改账号密码 -->
<template>
  <div class="person-center">
    <!-- 顶部蓝色缎面横幅 -->
    <div class="profile-banner">
      <div class="profile-avatar"><i class="el-icon-user-solid"></i></div>
    </div>

    <!-- 修改账号密码 -->
    <div class="content-wrap">
      <div class="panel form-panel">
        <!-- 卡片头部：图标 + 标题 + 说明 -->
        <div class="form-header">
          <div class="header-icon"><i class="el-icon-lock"></i></div>
          <div class="header-text">
            <div class="header-title">修改账号密码</div>
            <div class="header-sub">修改成功后需要使用新密码重新登录</div>
          </div>
        </div>

        <!-- 账号信息（只读） -->
        <div class="account-box">
          <div class="account-item">
            <span class="account-label">登录账号</span>
            <span class="account-value">{{ form.username || "-" }}</span>
          </div>
          <div class="account-item">
            <span class="account-label">手机号</span>
            <span class="account-value">{{ form.phone_number || "暂未绑定" }}</span>
          </div>
          <div class="account-tip">账号 / 手机号如需变更，请联系管理员修改</div>
        </div>

        <!-- 密码表单 -->
        <el-form
          ref="form"
          :model="form"
          label-position="top"
          class="pwd-form"
        >
          <el-form-item label="原密码" required>
            <el-input
              v-model="form.oldPassword"
              type="password"
              show-password
              placeholder="请输入原密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" required>
            <el-input
              v-model="form.password"
              type="password"
              show-password
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" required>
            <el-input
              v-model="form.confirmPassword"
              type="password"
              show-password
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
          <div class="pwd-tip">密码长度不少于 6 位，提交后密码将自动加密</div>
        </el-form>

        <div class="form-actions">
          <el-button class="btn-cancel" @click="resetForm">重 置</el-button>
          <el-button class="btn-confirm" type="primary" @click="save"
            >保存修改</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loginOut } from "@/services/user/index";
import { updatePassword } from "@/services/supAdmin/user.js";

export default {
  async created() {
    this.syncUserInfo();
  },
  data() {
    return {
      /* 表单：账号信息只读，密码可改 */
      form: {
        username: "",
        phone_number: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
    userInfo: {
      handler() {
        this.syncUserInfo();
      },
      deep: true,
    },
  },
  methods: {
    /* 同步账号基础信息 */
    syncUserInfo() {
      this.form.username = this.userInfo.username || "";
      this.form.phone_number = this.userInfo.phone_number || "暂未绑定手机号";
    },

    /* 重置密码输入 */
    resetForm() {
      this.form.oldPassword = "";
      this.form.password = "";
      this.form.confirmPassword = "";
    },

    /* 保存修改密码 */
    save() {
      if (
        !this.form.oldPassword ||
        !this.form.password ||
        !this.form.confirmPassword
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error("两次输入的新密码不一致");
        return;
      }
      if (this.form.password.length < 6) {
        this.$message.error("新密码长度不能少于 6 位");
        return;
      }

      this.$confirm("此操作将覆盖之前的密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const result = await updatePassword({
            ...this.userInfo,
            password: this.form.password,
            oldPassword: this.form.oldPassword,
          });
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.resetForm();

            setTimeout(() => {
              this.$router.push({ name: "Login" });
              loginOut({ id: this.userInfo.id }).then((resp) => {
                this.$message({
                  type: "success",
                  message: "已安全退出账户!",
                });
              });
            }, 800);
          } else {
            this.$message.error("原密码错误");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.person-center {
  width: 100%;
}

/* 顶部蓝色缎面横幅 */
.profile-banner {
  /* 缎面质感：细密斜纹 + 宽柔主光泽带 + 柔光晕 + 灰蓝暗部 */
  background-color: #3d8dfc;
  background-image: repeating-linear-gradient(
      115deg,
      rgba(255, 255, 255, 0.06) 0px,
      rgba(255, 255, 255, 0.06) 1px,
      rgba(255, 255, 255, 0) 1px,
      rgba(255, 255, 255, 0) 7px
    ),
    linear-gradient(
      115deg,
      rgba(255, 255, 255, 0) 16%,
      rgba(255, 255, 255, 0.3) 32%,
      rgba(255, 255, 255, 0.17) 45%,
      rgba(255, 255, 255, 0.05) 56%,
      rgba(255, 255, 255, 0) 66%
    ),
    radial-gradient(
      ellipse 70% 55% at 24% 0%,
      rgba(226, 240, 255, 0.42) 0%,
      rgba(226, 240, 255, 0) 62%
    ),
    radial-gradient(
      ellipse 65% 60% at 88% 100%,
      rgba(120, 145, 180, 0.34) 0%,
      rgba(120, 145, 180, 0) 66%
    ),
    linear-gradient(
      135deg,
      #7fb3ff 0%,
      #4a95ff 38%,
      #2f7be0 72%,
      #2268cf 100%
    );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35),
    inset 0 -30px 60px rgba(80, 102, 140, 0.25);
  /* 与下方白色卡片同宽居中，不再通栏 */
  max-width: 560px;
  /* 顶部留出正常间距，不再抵顶 */
  margin: 16px auto 16px;
  border-radius: 12px 12px 0 0;
  /* 底部留白，让头像下方露出少量蓝色背景 */
  padding: 18px 24px 24px;
  display: flex;
  /* 头像左对齐，不再居中 */
  align-items: center;
  justify-content: flex-start;
  color: #fff;

  .profile-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #fff;
    border: 3px solid rgba(255, 255, 255, 0.9);
    color: #3d8dfc;
    font-size: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(29, 33, 41, 0.15);
  }
}

/* 内容区：居中表单面板 */
.content-wrap {
  display: flex;
  justify-content: center;
  padding-bottom: 24px;
}

.panel {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
}

.form-panel {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  /* 轻微叠层，保留头像下方的蓝色可见 */
  margin-top: -16px;
  border-radius: 12px;
  padding: 28px 32px 24px;
  box-shadow: 0 8px 24px rgba(29, 33, 41, 0.08);
}

/* 卡片头部：蓝色图标块 + 标题说明 */
.form-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .header-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #e8f3ff;
    color: #3d8dfc;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .header-title {
    font-size: 17px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
  }
  .header-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #86909c;
    line-height: 16px;
  }
}

/* 账号信息只读块 */
.account-box {
  background: #f7f8fa;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 22px;

  .account-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0;

    .account-label {
      font-size: 13px;
      color: #86909c;
    }
    .account-value {
      font-size: 14px;
      font-weight: 500;
      color: #1d2129;
    }
  }
  .account-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #a9aeb8;
    line-height: 16px;
  }
}

/* 密码表单：标签在上 + 浅灰圆角输入框 */
.pwd-form {
  width: 100%;

  /deep/ .el-form-item {
    margin-bottom: 18px;
  }
  /deep/ .el-form-item__label {
    padding: 0 0 8px;
    line-height: 20px;
    font-size: 13px;
    color: #1d2129;
    font-weight: 500;
  }
  /deep/ .el-input__inner {
    background: #f2f3f5;
    border: none;
    border-radius: 8px;
    height: 44px;
    line-height: 44px;
    color: #1d2129;
    font-size: 14px;
    transition: box-shadow 0.15s ease, background 0.15s ease;
  }
  /deep/ .el-input__inner:focus {
    background: #f2f3f5;
    box-shadow: 0 0 0 2px rgba(61, 141, 252, 0.18);
  }
  /deep/ .el-input__inner::placeholder {
    color: #a9aeb8;
  }
  .pwd-tip {
    font-size: 12px;
    color: #86909c;
    line-height: 16px;
  }
}

/* 底部操作按钮：方圆样式 */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;

  .btn-cancel,
  .btn-confirm {
    height: 36px;
    min-width: 104px;
    border-radius: 6px;
    font-size: 14px;
    padding: 0;
    transition: all 0.15s ease;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #dcdee3;
    color: #4e5969;

    &:hover {
      color: #1d2129;
      border-color: #c9cdd4;
      background: #f7f8fa;
    }
  }
  .btn-confirm {
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    color: #fff;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}
</style>
